var map = {
	"./act": 1525,
	"./act.ts": 1525,
	"./gmat": 1526,
	"./gmat.ts": 1526,
	"./gre": 1527,
	"./gre.ts": 1527,
	"./ielts": 1528,
	"./ielts.ts": 1528,
	"./ielts_general_training": 1529,
	"./ielts_general_training.ts": 1529,
	"./lsat": 1530,
	"./lsat.ts": 1530,
	"./mcat": 1531,
	"./mcat.ts": 1531,
	"./sat": 1532,
	"./sat.ts": 1532,
	"./toefl": 1533,
	"./toefl.ts": 1533
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2535;
module.exports = webpackAsyncContext;